import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * ¿QUEDA ALGO POR VER A LOS LADOS? Lo que se desliza de lado tiene que decirlo (Jesús, punto
 * 51): la barra del navegador en un móvil ni se ve. Esto solo mide; cada componente lo dice
 * a su manera: una sombra en las tablas (`ui/TablaDeslizable`) y una flecha que avanza en las
 * filas de chips (`FilaConFlechas`, Enrique 16-10).
 *
 * Se mira al montar, tras cada pintada (cambia lo que hay dentro), al desplazar (`medir`, en
 * el `onScroll`) y cuando cambia el ancho de la caja. `holgura`: los píxeles que no cuentan,
 * por los anchos con decimales (sin ella, lo que cabe justo dice que le queda algo).
 *
 * Devuelve `{ ref, medir, hay: { izq, der } }`.
 */
export const hayMas = (el, holgura) => ({
    izq: el.scrollLeft > holgura,
    der: el.scrollLeft + el.clientWidth < el.scrollWidth - holgura,
});

export function useHayMasALosLados(holgura = 1) {
    const ref = useRef(null);
    const [hay, setHay] = useState({ izq: false, der: false });
    const medir = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        const ahora = hayMas(el, holgura);
        setHay((h) => (h.izq === ahora.izq && h.der === ahora.der ? h : ahora));
    }, [holgura]);
    useEffect(medir);
    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', medir);
            return () => window.removeEventListener('resize', medir);
        }
        const ro = new ResizeObserver(medir);
        ro.observe(el);
        return () => ro.disconnect();
    }, [medir]);
    return { ref, medir, hay };
}
